import React, { ReactElement, useState } from 'react';
import { useParams } from 'react-router';
import { LoaderButton } from 'idsk-react-components';
import routes from '../../../routing/routes';
import { downloadExportedFile } from '../../../client/exportClient';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';
import { processIsInMpk } from '../../../function/permissions';
import TypPripomienky from '../../../model/pripomienka/TypPripomienky';
import LegislationProcessInfo from '../../../model/currentuser/LegislationProcessInfo';
import './exportPodporovatelovButton.scss';
import { useSecurityContext } from '../../../context/SecurityContext';
import { useErrorMessageContext } from '../../../context/ErrorMessageContext';

interface Props {
  pocetPodporovatelov: number;
  pripomienkaType: TypPripomienky;
  legislationProcess: LegislationProcessInfo;
}

const ExportPodporovatelovButton = (
  { pocetPodporovatelov, legislationProcess, pripomienkaType } : Props,
): ReactElement => {
  const {
    type, year, index, uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();

  const [disabled, setDisabled] = useState<boolean>(false);
  const { accessToken, organizationId } = useSecurityContext();
  const { displayError } = useErrorMessageContext();

  const handleClick = (): void => {
    downloadExportedFile(
      routes.export.podporovatelia.withParams(type, year, index, uuid),
      'Zvolená hromadná pripomienka nemá žiadnych podporovateľov.',
      setDisabled,
      undefined,
      accessToken,
      organizationId,
    ).then(errorMessage => {
      if (errorMessage) {
        displayError(errorMessage);
      }
    });
  };

  return (
    <Secured
      allowForRoles={[UserRole.VYHODNOCOVATEL, UserRole.SUPERADMIN]}
      additionalCheck={processIsInMpk(legislationProcess) && pripomienkaType === TypPripomienky.HROMADNA}
    >
      <LoaderButton
        buttonStyle="primary"
        size="large"
        className="export-podporovatelov-button"
        loading={disabled || pocetPodporovatelov === 0}
        onClick={handleClick}
        withIcon={pocetPodporovatelov > 0}
      >
        Export podporovateľov
      </LoaderButton>
    </Secured>
  );
};

export default ExportPodporovatelovButton;
